module.exports = __webpack_public_path__ + "img/photo6.69fa85bf.png";